<div class="on-demand-pickup-wrapper">
  <app-modal-frame
    [headerText]="CONSTS.HEADER"
    [rightButton]="{
      text: CONSTS.SAVE,
      disable: disableButton,
      type: BUTTON_TYPES.ICON_TEXT_BUTTON,
    }"
    (emitExit)="clickExit()"
    (emitRightClick)="onSubmit()"
  >
    <div class="content">
      Scheduling
      <app-scheduling-section
        [data]="data.data.response.onDemandPickup"
        [form]="schedulingForm"
      ></app-scheduling-section>

      <!-- Current Pickup Address -->
      <app-current-pickup-section
        [currentPickupAddressData]="data.data.response.currentPickupAddress"
        [parsedAAAAddressData]="data.data.response.parsedAAAAddress"
        [originalAddressData]="data.data.response.originalAddress"
        [countryCode]="data.countryCode"
        [orderNumber]="
          data.data.response.onDemandPickup
            ? data.data.response.onDemandPickup.requestShipperNo
            : ''
        "
        [form]="currentPickupForm"
        (addressValidated)="addressValidated($event)"
      ></app-current-pickup-section>

      <!-- Notes -->
      <app-notes-section [form]="notesForm"></app-notes-section>
    </div>
  </app-modal-frame>
</div>
